import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import { SignOut } from "@phosphor-icons/react";

const ModalExcludeAta = ({ show, onDeleteClick, onCloseClick, data }) => {
	return (
		<Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16 mb-4">
						Tem certeza de que deseja inativar a ata?
					</p>
					<p className="text-muted font-size-16 mb-4 fw-bold">
						{data?.name}
					</p>

					<div className="hstack gap-2 justify-content-center mb-0">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={() => onDeleteClick(data.id)}
						>
							Confirmar
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

ModalExcludeAta.propTypes = {
	onCloseClick: PropTypes.func,
	onDeleteClick: PropTypes.func,
	show: PropTypes.bool,
	data: PropTypes.any,
};

export default ModalExcludeAta;
